import CharacterObject from "../../../types/CharacterObject"

const configure = (rawText: {text: string}[]) => {
  let i = 1
  const text:CharacterObject[][][] = rawText.map(page => page.text.split('\n').map(paragraph => paragraph.split('').map(char => ({c: char, i: i++}))))

  return text
}

export default configure